var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerFastForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2,45.1v-2.3c0-0.4,0.2-0.8,0.6-1l6.2-3.7c0.2-0.1,0.4-0.2,0.6-0.2h2.8c0.7,0,1.2,0.5,1.2,1.2v24.3 c0,0.7-0.5,1.2-1.2,1.2h-2.5c-0.7,0-1.2-0.5-1.2-1.2V43.6c0-0.2-0.2-0.3-0.3-0.2L29,46.1C28.2,46.6,27.2,46,27.2,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,51.2c0-4.2,0.8-7.6,2.5-10c1.7-2.5,4-3.7,7.1-3.7c3.1,0,5.4,1.2,7.1,3.7c1.7,2.5,2.5,5.8,2.5,10 c0,4.2-0.8,7.5-2.5,10c-1.6,2.5-4,3.8-7.2,3.8c-3,0-5.4-1.3-7.1-3.8C44.5,58.7,43.6,55.3,43.6,51.2z M49.9,44.3 c-0.8,1.6-1.2,3.9-1.2,6.9c0,3,0.4,5.3,1.2,6.9c0.8,1.6,1.9,2.4,3.3,2.4c1.5,0,2.6-0.8,3.4-2.4c0.8-1.6,1.2-3.9,1.2-6.9 c0-3-0.4-5.3-1.2-6.9c-0.8-1.6-2-2.4-3.4-2.4C51.8,41.9,50.7,42.7,49.9,44.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.4,21.8c-0.9-0.6-3.2-1.7-4.2,0.1C59,24,60.5,25.3,61,25.7c8,5.2,13.3,14.2,13.3,24.5 c0,16.1-13.1,29.3-29.3,29.3S15.7,66.3,15.7,50.2c0-14.1,10-25.8,23.2-28.6v6.1c0,1,1.1,1.6,1.9,1.1l15.5-9.8 c0.8-0.5,0.8-1.6,0-2.1L40.9,7c-0.8-0.5-1.9,0.1-1.9,1.1v8.3c-16.1,2.9-28.3,16.9-28.3,33.8c0,19,15.4,34.4,34.4,34.4 c19,0,34.4-15.4,34.4-34.4C79.4,38.4,73.4,28,64.4,21.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFastForward);
export default __webpack_public_path__ + "static/media/playerFastForward.7ad1dceca2d63b09fc0ee3cf9ea96a2d.svg";
export { ForwardRef as ReactComponent };